module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/reverb-logo-126cdaebe5154e7ea62c4ae2f924449c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/reverb-logo.svg
// module id = lCKi
// module chunks = 24